import React, { FC, ReactNode } from "react";
import classNames from "classnames";

type Props = {
  onClick: () => void;
  children?: ReactNode;
};

export const ControlButton: FC<Props> = ({ children, onClick }) => (
  <button
    role="button"
    className={classNames(
      "bg-divider flex h-11 w-11 items-center justify-center rounded-full",
      "xxl:h-13 xxl:w-13",
    )}
    onClick={onClick}
  >
    {children}
  </button>
);
